(function() {
  'use strict';

  function myTrackingBar($filter, $compile, $timeout) {

    function controller($filter) {

      /**
       * retorna diferença entre dois pontos
       * caso não tenha a data final é somado 2 dias ao inicio, fazendo a barra sempre conter 3 pontos
       */
      function diffBetweenPoints(initialPoint, finalPoint) {
        if (!initialPoint && !finalPoint) {
          return 2;
        }

        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var final = finalPoint || (initialPoint + (oneDay * 2));
        return Math.round(Math.abs((final - initialPoint) / (oneDay)));
      }

      /**
       * transforma pixel em %
       * n1 é a quantidade que deseja saber a %
       * n2 é a referência para fazer o calculo
       */
      function pixelToPercent(n1, n2) {
        return (n1 / n2) * 100;
      }

      /**
       * formata a data para string contendo apenas dia/mes/ano
       * utilizada para comparação de dias
       */
      function dateFormat(date) {
        return $filter('date')(date, 'dd MM yy');
      }

      /**
       * constroi o array de progresso com as possiveis posições de progresso
       */
      function buildProgress(obj) {
        obj.progressBar = [];
        var result = diffBetweenPoints(obj.progresso.marcadores[0].data, obj.progresso.marcadores[obj.progresso.marcadores.length - 1].data);
        var diffDays = result < 2 ? 2 : result;
        for (var i = 0; i <= diffDays; i++) {
          var item = {}; // cria variavel com o obj a ser inserido na timeline, cada obj desse representa um dia
          item.position = ((i * 100) / (obj.progresso.marcadores.length - 1));
          obj.progressBar.push(item);
        }
        return obj;
      }

      /**
       * exposes
       */
      this.diffBetweenPoints = diffBetweenPoints;
      this.pixelToPercent = pixelToPercent;
      this.dateFormat = dateFormat;
      this.buildProgress = buildProgress;
    }

    function link($scope, $element, $attrs, $ctrl) {
      /**
       * verifica se o obj tem info, se tiver devolve o valor da propriedade, se não devolve a data formatada
       */
      function whichContent(obj) {
        return obj.info || $filter('myFormatDate')(obj.data);
      }

      /**
       * anima o progresso da barra e insere o icone no final
       */
      function progressAnimate(percent) {
        var limit = isNaN(percent) ? 0 : percent;
        var remaining = limit % 1;
        var start = 0;
        var trackingBar = document.querySelector('.track-bar');

        var frame = function() {
          if (start == Math.floor(limit)) {
            trackingBar.style.width = (start + remaining) + '%';
            if ($attrs.myStatus.progresso.entregue) {
              document.querySelector('.icon-success').style.display = 'block';
            }
            clearInterval(animateBar);
          } else {
            trackingBar.style.width = (start++) + '%';
          }
        };
        var animateBar = setInterval(frame, 5);

        $timeout(animateBar, 2000);

      }

      /**
       * calcula o progresso da barra
       */
      function getProgress(position, indexCurrentPosition) {
        var points = $attrs.myStatus.progresso.marcadores;
        var initial = new Date(points[0].data).getDate();
        // var day = 24 * 60 * 60 * 1000; // temporario
        // var final = new Date(points[0].data + (day * 3)).getDate();
        var final = new Date().getDate();
        var containerWidth = $element[0].clientWidth || document.querySelector('.box-tracking').clientWidth;
        var currentWidth = indexCurrentPosition ? $attrs.myStatus.progressBar[indexCurrentPosition].position + ($ctrl.pixelToPercent(12, containerWidth) / 2) : position;
        var withAlert = $ctrl.pixelToPercent(31, containerWidth);
        var trackBar = document.querySelector('.track-bar');
        var marker = points.length;

        for (var i = 0; i < marker; i++) {
          if (!points[i].etapaConcluida) {
            if (i == 1 && points[0].etapaConcluida) {
              // o progresso será apenas o ponto inicial
              trackBar.style.width = $ctrl.pixelToPercent(26, containerWidth) + '%';
              break;
            } else if (i == 2 && points[1].etapaConcluida) {
              if (final - initial === 0) {
                // o progresso ficará no mesmo lugar se for no mesmo dia
                progressAnimate(currentWidth + $ctrl.pixelToPercent(12, containerWidth));
                break;
              } else if ($attrs.myStatus.progresso.alerta && $attrs.myStatus.progresso.extravio) {
                // progresso tem a postagem concluida, tem alerta e é extravio
                progressAnimate($attrs.myStatus.progressBar[$attrs.myStatus.progressBar.length - 2].position - withAlert);
                break;
              } else {
                if ($attrs.myStatus.progresso.alerta) {
                  // se a barra contem alerta, precisamos subtrair o tamanho do alert
                  if (currentWidth > (100 - withAlert)) {
                    progressAnimate(100 - ($ctrl.pixelToPercent(26, containerWidth) + withAlert));
                  } else {
                    progressAnimate(currentWidth);
                  }

                } else {
                  // progresso normal para add uma part a posição atual
                  progressAnimate(currentWidth);
                }
                break;
              }
            }
          } else if ($attrs.myStatus.progresso.entregue && points[i].etapaConcluida) {
            // progresso concluido
            // trackBar.style.width = 100 + '%';
            progressAnimate(100);
            break;
          }
        }
      }

      /**
       * seta a position encontrada pela função searchPosition
       */
      function setPosition(el, point, index, position) {
        var pos = index ? $attrs.myStatus.progressBar[index].position : position;
        var trackingBarWidth = document.querySelector('.box-tracking').clientWidth;
        var halfPoint = $ctrl.pixelToPercent(point.clientWidth, trackingBarWidth) / 2;

        el.style.left = pos + '%';
        if ((pos - $ctrl.pixelToPercent(88, trackingBarWidth)) > $ctrl.pixelToPercent(176, trackingBarWidth)) {
          el.className += ' status-text-align-middle';
          point.style.left = (pos - halfPoint) + '%';
        } else {
          point.style.left = pos + '%';
        }

        if (index) {
          getProgress($attrs.myStatus.progressBar[index].position, index);
        }

      }

      /**
       * posiciona o elemento intermediario
       * verifica se a mensagem de postagem contem a mesma data de preparando para envio,
       * se houver precisa alinhar logo após o primeiro item,
       * se não precisa apontar de acordo com a data
       */
      function searchPosition(el, point) {
        var middleElWidth = '';
        var barContainerWidth = '';
        // var diff = $ctrl.diffBetweenPoints($attrs.myStatus.progresso.marcadores[0].data, $attrs.myStatus.progresso.marcadores[1].data);
        var trackBar = $attrs.myStatus.progressBar.length;
        $timeout(function() {
          middleElWidth = document.querySelectorAll('.status-text')[1].clientWidth || 167;
          barContainerWidth = $element[0].clientWidth || document.querySelector('.box-tracking').clientWidth;

          for (var i = 0; i < trackBar; i++) {
            if ($attrs.myStatus.progressBar[i].position > $ctrl.pixelToPercent(middleElWidth, barContainerWidth)) {
              setPosition(el, point, i);
              break;
            }
          }
        })
      }

      /**
       * posiciona os elementos que contem as mensagens de status
       * verifica situações que tornam o exibimento da barra padrão,
       * alinha ultimo elemento de status,
       * e busca posição do elemento intermediário
       */
      function positionElements() {
        /**
         * variaveis de regras
         */
        var cancelOrUnfinished = ($attrs.myStatus.progresso.marcadores[0].info || $attrs.myStatus.situacaoEncomenda == 'Cancelada' || $attrs.myStatus.situacaoPedido == 'Cancelada');
        var divergent = $attrs.myStatus.progresso.alerta && !$attrs.myStatus.progresso.marcadores[1].etapaConcluida;
        var success = $attrs.myStatus.progresso.entregue;
        var loss = $attrs.myStatus.progresso.extravio;
        var alert = $attrs.myStatus.progresso.alerta;
        /**
         * variaveis de elementos
         */
        var trackBar = document.querySelector('.track-bar');
        var elements = document.querySelectorAll('.status-text');
        var points = document.querySelectorAll('.point-item');

        /**
         * seta a posição do ultimo elemento e add classe especifica para posição
         */
        elements[elements.length - 1].style.right = 0;
        elements[elements.length - 1].className += ' status-text-align-right';

        if (cancelOrUnfinished || divergent) {
          var centerPos = $attrs.myStatus.progressBar[(Math.floor($attrs.myStatus.progressBar.length / 2))].position;
          if (typeof cancelOrUnfinished != 'string') { // se for do tipo string quer dizer que o primeiro obj tem info, se não será um booleano
            trackBar.className += ' track-alert';
          } else if (divergent) {
            trackBar.className += ' track-alert';
          }
          setPosition(elements[1], points[1], null, centerPos);
        } else {
          if (success) {
            trackBar.className += ' track-success';
          } else if (loss) {
            trackBar.className += ' track-cancel';
          } else if (alert) {
            trackBar.className += ' track-alert';
          }
        }
        searchPosition(elements[1], points[1]);
      }

      /**
       * cria elementos para exibir as msgs e datas previstas
       */
      function buildMessages() {
        var alert = '<i class="status-text-alert" popover-placement="left" popover="O prazo de entrega não contempla feriados e é fornecido pela transportadora responsável pela entrega. A Mandaê não se responsabiliza por atrasos." popover-trigger="mouseenter"><svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 107.3 107.3" enable-background="new 0 0 107.3 107.3" xml:space="preserve"><g><path fill="#ff7865" d="M48.6,37.4h9.7c0.6,0,1-0.4,1-1v-9.7c0-0.6-0.4-1-1-1h-9.7c-0.6,0-1,0.4-1,1v9.7C47.6,37,48.1,37.4,48.6,37.4z"/><path fill="#ff7865" d="M63.5,70.3h-4.1V51.2v-6.9c0-0.6-0.4-1-1-1h-9.7h-5.1c-0.6,0-1,0.4-1,1v6.9c0,0.6,0.4,1,1,1h4.1v18.2h-4.1c-0.6,0-1,0.4-1,1v6.9c0,0.6,0.4,1,1,1h5.1h9.7h5.1c0.6,0,1-0.4,1-1v-6.9C64.5,70.8,64,70.3,63.5,70.3z"/><path fill="#ff7865" d="M53.7,0C24.1,0,0,24.1,0,53.7s24.1,53.7,53.7,53.7s53.7-24.1,53.7-53.7S83.3,0,53.7,0z M53.7,99.3C28.5,99.3,8,78.8,8,53.7S28.5,8,53.7,8s45.7,20.5,45.7,45.7S78.8,99.3,53.7,99.3z"/></g></i>';
        // var containerMsg = document.querySelector('.my-status');
        // var containerPoints = document.querySelector('.status-point');
        var containerMsg = angular.element('.my-status');
        var containerPoints = angular.element('.status-point');
        var marker = $attrs.myStatus.progresso.marcadores.length;

        /**
         * cria os elementos e insere no obj publico usado pela view
         * dispara a função para posicionar os elementos
         */
        for (var i = 0; i < marker; i++) {
          var msg = $compile('<p class="status-text"><span class="status-text-message">' + $attrs.myStatus.progresso.marcadores[i].mensagem + '</span><small class="text-aux">' + ((i == ($attrs.myStatus.progresso.marcadores.length - 1) && !$attrs.myStatus.progresso.marcadores[i].info) ? alert : '') + whichContent($attrs.myStatus.progresso.marcadores[i]) + '</small></p>')($scope);
          var point = angular.element('<span class="point-item point-item-' + i + '"></span>');
          if (containerMsg) {
            containerMsg.append(msg[0]);
            containerPoints.append(point[0]);
          }
        }
        positionElements();

      }

      /**
       * dispara watch para saber quando o dado esta pronto
       * quando pronto disparamos novamente para remove-lo, ja que o dado esperado ja existe
       */
      var unwatchData = $scope.$watch(function() {
        return $scope.myStatus;
      }, function(newValue, oldValue) {
        if (newValue) {
          $attrs.myStatus = $ctrl.buildProgress(newValue);
          buildMessages();
          // remove the watch
          unwatchData();
        }
      });
    }

    // function compile(tElement, tAttrs) {
    //   return {
    //     pre: function preLink(scope, iElement, iAttrs, controller) {
    //       console.log('pre ' + scope, iElement, iAttrs, controller);
    //     },
    //     post: function postLink($scope, $element, $attrs, $ctrl) {

    //     }
    //   }
    // }

    var config = {
      restrict: 'E',
      replace: true,
      scope: {
        myStatus: '='
      },
      template: require('./tracking-bar.html'),
      controllerAs: 'vm',
      controller: ['$filter', controller],
      link: link,
      // compile: compile
    };

    return config;
  }

  angular
    .module('mandaeApp')
    .directive('myTrackingBar', myTrackingBar);

}());
